import { NotFoundErrorPage } from '@/app/pages/errors/not-found-error-page';
import { ExternalSubmitFeedback } from '@/app/pages/feedback/external-submit-feedback';
import { CustomErrorComponent } from '@/app/routes/__root';
import {
  createFileRoute,
  ErrorComponentProps,
  SearchParamError,
} from '@tanstack/react-router';

import { externalFeedbackSearchSchema } from '@/features/review/config/external-feedback-search-schema';

function ExternalFeedbackErrorComponent(props: ErrorComponentProps) {
  // Ссылка приходит из внешней рассылки: не прошедшие валидацию параметры
  // означают испорченную ссылку, а не аварию сервиса.
  if (props.error instanceof SearchParamError) {
    return <NotFoundErrorPage />;
  }

  return <CustomErrorComponent {...props} />;
}

export const Route = createFileRoute('/external-feedback/')({
  validateSearch: externalFeedbackSearchSchema,
  component: ExternalSubmitFeedback,
  errorComponent: ExternalFeedbackErrorComponent,
});
